import Vue from "vue";
import Vuex from "vuex";
import Toasted from "vue-toasted";

Vue.use(Toasted, {
  position: "bottom-right",
  duration: 5000,
  // keepOnHover: true,
  iconPack: "custom-class"
});
Vue.use(Vuex);
import tools from "./namespaced/tools";
import toast from "./namespaced/toast";
import ble from "./namespaced/ble";
import lang from "./namespaced/lang";
import ras from "./namespaced/FlipRas/ras";
import weather from "./namespaced/weather";

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    tools,
    toast,
    ble,
    lang,
    ras,
    weather
  }
});
